import WizardContainer from "./BusinessListingWizard";
import { useLocation } from "react-router-dom";

function BusinessListingWizardPersonal() {
    const location = useLocation();
    const { subscriptionId } = location?.state || {};
    return <WizardContainer step={1} subscriptionId={subscriptionId} />;
}

export default BusinessListingWizardPersonal;
